export class KeyValuePair<TKey, TValue> {
  public key: TKey;
  public value: TValue;

  clone(): KeyValuePair<TKey, TValue> {
    const pair = new KeyValuePair<TKey, TValue>();
    pair.key = this.key;
    pair.value = this.value;
    return pair;
  }
}
